import Link from 'next/link';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';

import styles from './auth.module.scss';
import formStyles from 'legacy/common/components/form/Form.module.scss';

import FormWrapper from 'legacy/auth/components/FormWrapper';
import SocialLogin from 'legacy/auth/components/legacy/SocialLogin';
import Wrapper from 'legacy/common/components/layout/BackgroundWrapper';
import EmailLoginForm from 'legacy/auth/components/legacy/EmailLoginForm';
import { useRouter } from 'next/router';
import { FLAGS } from 'legacy/common/constants/launchdarkly';

const EmailLogin = () => {
  const { t } = useTranslation('auth');
  const flags = useFlags();
  const { query } = useRouter();

  return (
    <Wrapper>
      <FormWrapper>
        <EmailLoginForm />
        <div className={styles.forgotPassword}>
          {t('emailLogin.forgotPassword')}{' '}
          <Link href="/login/resetPassword" className={styles.link}>
            {t('emailLogin.resetLink')}
          </Link>
        </div>

        {!flags[FLAGS.ENABLE_NEW_LOGIN_SCREEN] && (
          <>
            <div className={formStyles.separator}>
              <span />
              <div>{t('emailLogin.orSeparator')}</div>
              <span />
            </div>
            <SocialLogin />
          </>
        )}

        <div className={formStyles.separator}>
          <span />
          <div>{t('emailLogin.orSeparator')}</div>
          <span />
        </div>
        <div className={styles.actionItem}>
          <Link
            href={{
              pathname: '/register',
              query
            }}
            data-test="sign-up"
            className={formStyles.button}
          >
            {t('emailLogin.signUpButton')}
          </Link>
        </div>
      </FormWrapper>
    </Wrapper>
  );
};

export default EmailLogin;
